import { makeRequest } from 'utils/requestLogger';

export default (id,query= null) => {
  if (query){
      const {include_submissions,submission_id} = query;
      if (include_submissions) 
        return makeRequest('get', `/api/roundtables/${id}/?include_submissions=${query.include_submissions}`).then((res) => res.data);
      else if (submission_id)
        return makeRequest('get', `/api/roundtables/${id}/?submission_id=${query.submission_id}`).then((res) => res.data);
  }
  return makeRequest('get', `/api/roundtables/${id}`,query).then((res) => res.data);
};




// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/loadRoundtable.js